import script from "./popup-intercept-trend-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./popup-intercept-trend-chart.vue?vue&type=script&lang=ts&setup=true"

import "./popup-intercept-trend-chart.vue?vue&type=style&index=0&id=35160ffa&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35160ffa"]])

export default __exports__